import IconProps from './icon';

const IconArrowFilled = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.49994 10L0 0H10L5.49994 10Z" fill={props.color} />
    </svg>
  );
};

export default IconArrowFilled;
